var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.828.245c-1.046 0-1.9.79-2.019 1.804L11 8.416 21.19 2.05A2.036 2.036 0 0 0 19.17.245zM.785 4.077v10.468c0 1.128.914 2.042 2.043 2.042H19.17a2.04 2.04 0 0 0 2.043-2.042V4.077l-9.673 6.045c-.331.206-.75.206-1.082 0z"
})));
export default SvgEmail;